import { useFiltersStore } from '#stores/filters.store';
import { DetentionPeriodValueType } from '@carrefour-gcs/shared';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import type { KpisPerimeterType } from './kpisPerimeter';

export const useDetentionPeriod = (): KpisPerimeterType['detentionPeriod'] => {
  const filtersStore = useFiltersStore();
  const { filters } = storeToRefs(filtersStore);

  const detentionPeriod = computed<DetentionPeriodValueType>(() => {
    return filters.value.detentionPeriod ?? DetentionPeriodValueType['14Days'];
  });

  const updateDetentionPeriod = (value: DetentionPeriodValueType) => {
    filtersStore.setFilter('detentionPeriod', value);
  };

  const isDefault = (currentValue = detentionPeriod.value) => currentValue === DetentionPeriodValueType['14Days'];

  return {
    detentionPeriod,
    updateDetentionPeriod,
    isDefault
  };
};
